<template>
  <Headlins />
</template>
<script>
import appConfig from '@/app.config'
import Headlins from '../../../../components/mooc/headlins/index'
export default {
  page: {
    title: 'مدیریت سرفصل ها',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'mooc-headlines-courses',
  components: {
    Headlins,
  },
}
</script>
